import { BridgeComponent } from '@hotwired/hotwire-native-bridge'

// Photothèque directe (PHPicker) à la place de la feuille système à trois choix
// de WKWebView (Photothèque / Prendre une photo / Choisir un fichier).
//
// Sur un bouton, l'action #pick n'est posée que si la coquille déclare le
// composant (`native_bridge_component?`) : sans contrôleur chargé (Share
// Extension iOS), le tap tomberait dans le vide. Sur un label ou l'input
// lui-même, le clic par défaut ouvre l'input fichier et sert de repli.
// L'image choisie revient en base64, reconstruite en File et posée dans l'input
// via DataTransfer — la chaîne existante (aperçu image-preview, upload au
// submit) ne voit pas la différence avec une sélection système.
export default class extends BridgeComponent {
  static component = 'photo-picker'
  static targets = ['input']

  pick(event) {
    event.preventDefault()
    event.stopPropagation()

    this.send('pick', {}, (message) => {
      const { data, name, type } = message.data
      const bytes = Uint8Array.from(atob(data), (char) => char.charCodeAt(0))
      const transfer = new DataTransfer()
      transfer.items.add(new File([bytes], name || 'photo.jpg', { type: type || 'image/jpeg' }))

      // Le scraper désactive l'input quand une vignette scrapée est choisie —
      // un input disabled serait ignoré au submit.
      this.inputTarget.disabled = false
      this.inputTarget.files = transfer.files
      // Une sélection système émet input puis change — on rejoue les deux.
      this.inputTarget.dispatchEvent(new Event('input', { bubbles: true }))
      this.inputTarget.dispatchEvent(new Event('change', { bubbles: true }))
    })
  }
}
